export default __webpack_public_path__ + "static/media/Chrissie 9781846165061.605401bf.jpg";